import { render, staticRenderFns } from "./HttpImg.vue?vue&type=template&id=07ff567e&scoped=true"
import script from "./HttpImg.vue?vue&type=script&lang=js"
export * from "./HttpImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff567e",
  null
  
)

export default component.exports